import clsx from 'clsx';
import { Icon } from '@iconify/react';
import { PATH_APP } from 'routes/paths';
import MyAvatar from 'components/MyAvatar';
import React, { useRef, useState } from 'react';
import PopoverMenu from 'components/PopoverMenu';
import useIsMountedRef from 'hooks/useIsMountedRef';
import homeFill from '@iconify-icons/eva/home-fill';
import settingsFill from '@iconify-icons/eva/settings-fill';
import { Link as RouterLink } from 'react-router-dom';
import { alpha, makeStyles } from '@material-ui/core/styles';
import { Button, Box, Divider, MenuItem, Typography } from '@material-ui/core';
import { MIconButton } from '@material-extend';

// ----------------------------------------------------------------------

const MENU_OPTIONS = [
  {
    label: 'Home',
    icon: homeFill,
    linkTo: '/app/dashboard'
  },
  {
    label: 'Settings',
    icon: settingsFill,
    linkTo: PATH_APP.management.user.account
  }
];

const useStyles = makeStyles(theme => ({
  menuItem: {
    ...theme.typography.body2,
    padding: theme.spacing(1, 2.5)
  },
  btnAvatar: {
    padding: 0,
    width: 44,
    height: 44
  },
  isSelected: {
    '&:before': {
      zIndex: 1,
      content: "''",
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      position: 'absolute',
      background: alpha(theme.palette.grey[900], 0.8)
    }
  },
  divider: {
    margin: theme.spacing(1, 0)
  }
}));

// ----------------------------------------------------------------------

function Account() {
  const classes = useStyles();
  const anchorRef = useRef(null);
  const isMountedRef = useIsMountedRef();
  // const { enqueueSnackbar } = useSnackbar();
  const [isOpen, setOpen] = useState(false);
  const { profile } = global.currentUser;
  const displayName = (!!profile && `${profile.first_name} ${profile.last_name}`) || '';

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleLogout = async () => {
    try {
      localStorage.removeItem('Authorization-Token')
      setTimeout(() => {
        if (isMountedRef.current) {
          window.location.replace('/');
          handleClose();
        }
      }, 300)
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <MIconButton
        ref={anchorRef}
        onClick={handleOpen}
        className={clsx(classes.btnAvatar, { [classes.isSelected]: isOpen })}
      >
        <MyAvatar profile={global.currentUser} profileType="User" />
      </MIconButton>

      <PopoverMenu
        width={220}
        open={isOpen}
        onClose={handleClose}
        anchorEl={anchorRef.current}
      >
        <Box sx={{ my: 2, px: 2.5 }}>
          <Typography variant="subtitle1" color="textPrimary" noWrap>
            {displayName}
          </Typography>
          <Typography variant="body2" color="textSecondary" noWrap>
            {global.currentUser.email}
          </Typography>
        </Box>

        <Divider className={classes.divider} />

        {MENU_OPTIONS.map(option => (
          <MenuItem
            key={option.label}
            to={option.linkTo}
            component={RouterLink}
            onClick={handleClose}
            className={classes.menuItem}
          >
            <Box
              component={Icon}
              icon={option.icon}
              sx={{
                mr: 2,
                width: 24,
                height: 24
              }}
            />

            {option.label}
          </MenuItem>
        ))}

        <Box sx={{ p: 2, pt: 1.5 }}>
          <Button
            fullWidth
            color="inherit"
            variant="outlined"
            onClick={handleLogout}
          >
            Logout
          </Button>
        </Box>
      </PopoverMenu>
    </>
  );
}

export default Account;
